/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NeighbourhoodUsage {
    RESIDENTIAL_USE = 'RESIDENTIAL_USE',
    INDUSTRY = 'INDUSTRY',
    MIXED_USE = 'MIXED_USE',
}
